/**
 * Extracts a user-friendly error message from an axios error response
 * Handles both string error messages and Pydantic validation error arrays
 * 
 * @param {Error} error - The axios error object
 * @param {string} fallbackMessage - Default message if no error details found
 * @returns {string} - User-friendly error message
 */
export const getErrorMessage = (error, fallbackMessage = 'An error occurred') => {
  if (!error.response?.data?.detail) {
    return fallbackMessage;
  }
  
  const detail = error.response.data.detail;
  
  // If detail is an array (Pydantic validation errors)
  if (Array.isArray(detail)) {
    // Extract the first error message
    return detail[0]?.msg || fallbackMessage;
  }
  
  // If detail is a string
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an object with a message property
  if (detail.message) {
    return detail.message;
  }
  
  return fallbackMessage;
};
